import React from "react";
import { Box, Image, Stack, VStack } from "@chakra-ui/react";

import { Logo } from "src/layout/Logo";

export default function App() {
  return (
    <VStack
      maxW="2xl"
      marginX="auto"
      h="100vh"
      justifyContent="center"
      paddingX={4}
      spacing={8}
    >
      <Logo maxHeight="64px" />
      <Box fontSize="md" textAlign="center">
        You can download the GateHawk app for your mobile device through the
        links below
      </Box>
      <Stack direction={["column", "row"]} alignItems="center">
        <a href="https://apps.apple.com/us/app/gatehawk/id1612874236">
          <Image
            height="48px"
            alt="Download on the iOS App Store"
            src="https://gatehawk-static.s3.us-west-2.amazonaws.com/apple-app-store.png"
          />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.levelup.gatehawk">
          <Image
            height="72px"
            alt="Download on the Google Play Store"
            src="https://gatehawk-static.s3.us-west-2.amazonaws.com/google-play-badge.png"
          />
        </a>
      </Stack>
    </VStack>
  );
}
